module.exports=function(scope){ return `{
    "data": {
        "sessionToken": "..."
    },
    "meta": {
        "code": 200,
        "ok": true,
        "message": "Session Token Generated Successfully."
    }
}`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/success/session-token.json.tpl